import useSWR from "swr";

import SWR_KEYS from "@/constants/swr-keys";
import { IGlobalVariable } from "@/interfaces/global-variable.interfaces";
import workflowService from "@/services/workflow.service";
import { PaginatedResponse, RequestsBaseReturn } from "@/types/requests.types";

type GetAllSwrParams = [string];

const useGetGlobalVariables = (): RequestsBaseReturn<PaginatedResponse<IGlobalVariable> | null> => {
  const fetcher = useSWR<PaginatedResponse<IGlobalVariable>, Error, GetAllSwrParams>(
    [SWR_KEYS.getGlobalVariables],
    () => workflowService.getAllGlobalVariables(),
    { revalidateOnFocus: false, shouldRetryOnError: false, errorRetryCount: 0 }
  );

  const { data = null, isValidating: isLoading, error } = fetcher;

  return { data, isLoading, error };
};

export default useGetGlobalVariables;
